import { DataTable, Spinner } from "@shopify/polaris";

import { LoadingContainer, NoCancellationData, UserTableWrapper } from "../../CancellationReasonsSettings/styles";
import { AttemptsTabConfig } from "./types";

export const getAttemptsTab = (isLoadingData: boolean, config: AttemptsTabConfig) => ({
  id: config.id,
  value: getAttemptsTabValue(isLoadingData, config),
  accessibilityLabel: config.label,
  content: config.label,
});

function getAttemptsTabValue(isLoadingData: boolean, config: AttemptsTabConfig) {
  if (isLoadingData) {
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );
  }

  if (config.isEmpty) {
    return (
      <NoCancellationData>
        <p>{config.emptyMessage}</p>
      </NoCancellationData>
    );
  }

  return (
    <UserTableWrapper>
      <DataTable
        columnContentTypes={["text", "numeric", "text", "text", "text"]}
        headings={config.headings}
        rows={config.rows! || []}
        sortable={[false, false, false, false, false]}
        defaultSortDirection="descending"
        initialSortColumnIndex={4}
      />
    </UserTableWrapper>
  );
}
